module.exports = __webpack_public_path__ + "assets/images/baace7e62b13947dd9638d6c00dade59-repair.png";